import {atom} from "recoil"

const canCanAtom = atom({
  key: "canCanAtom",
  dangerouslyAllowMutability: true, // Because the canCan from api maker uses a mutable lock :-(
  default: undefined
})

export {canCanAtom}
